export default "__VITE_ASSET__miLrJkhG__"